export default __webpack_public_path__ + "static/media/Strangler's Bracers of the Battlethrall.4a2abc92.jpg";